import styled from 'styled-components'

export const SectionContainer = styled.div`
  width: 100vw;
  max-width: 100%;
  `;

export const BackgroundImage = styled.div`   
  height:100vh;
  background-image:url(${props => props.img});        
  background-size:cover;
  background-position:center;
  background-repeat: no-repeat;          
`;

export const BackgroundVideo = styled.video`
  width:100%;
  height:inherit;  
  justify-content:center;
  object-fit:contain;  
`;